import gsap from "gsap";

import Flip from "gsap/Flip";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import Loadeer from "loadeer";

gsap.registerPlugin(Flip, ScrollTrigger, ScrollToPlugin);

// --------------------------------------------------
// 📏 Grid
// --------------------------------------------------

let grid = document.querySelector('.grid');

let toggleGrid = gsap.to(grid, {
  duration: .5,
  ease: 'power2.inOut',
  scaleY: 1,
  paused: true
}).reverse();

document.addEventListener('keydown', e => {
  if (e.key === 'g' && e.ctrlKey) {
    toggleGrid.reversed() ? toggleGrid.play() : toggleGrid.reverse();
    document.documentElement.classList.toggle('debug');
  }
})

// --------------------------------------------------
// 💤 Lazy Loading
// --------------------------------------------------

let lazyLoadedImages = document.querySelectorAll('[data-lazyload]');
const instance = new Loadeer(lazyLoadedImages, {
  onLoaded: (element) => {
    gsap.set(element, {
      autoAlpha: 0,
    })
    element.addEventListener('load', () => {
      let delay = 0;
      if(element.hasAttribute('data-delay')) {
        delay =  gsap.utils.random(0, 1);
      }
      let loadAnimation = gsap.timeline({
        delay
      });
      loadAnimation.to(element, {
        autoAlpha: 1,
        duration: 1,
        ease: 'power1.inOut',
      });
    })
  }
});
instance.observe();

// --------------------------------------------------
// ✨ Home Load Animation
// --------------------------------------------------

if(document.documentElement.dataset.template == "home") {
  let loadAnimation = gsap.timeline({
    paused: true,
    defaults: {
      ease: 'power1.inOut',
      duration: 1,
    }
  });

  loadAnimation.to('.header__mask', {
    scaleX: 0,
    duration: 2,
    ease: 'power3.inOut',
  })

  loadAnimation.to('.highlights__highlight ', {
    autoAlpha: 1,
    duration: 1.5
  }, '-=.25')

  loadAnimation.to('.intro__signet ', {
    autoAlpha: 0,
    duration: 1.5
  }, '<')

  window.addEventListener('load', () => {
    loadAnimation.play();
  })

  let highlights = gsap.utils.toArray('.highlights__highlight')

  highlights.forEach((highlight) => {
    let href = highlight.getAttribute('href');
    let menuItem = document.querySelector(`.menu-item[href="${href}"]`);
    if(menuItem) {
      highlight.addEventListener('mouseenter', () => {
        menuItem.classList.add('menu-item--open');
      })
      highlight.addEventListener('mouseleave', () => {
        menuItem.classList.remove('menu-item--open');
      })
    }
  })

}


// --------------------------------------------------
// 🍔 Hamburger
// --------------------------------------------------

let menuToggle = document.querySelector('.menu-toggle');
let menu = document.querySelector('.mobile-menu');

menuToggle.addEventListener('click', e => {
  menu.classList.toggle('mobile-menu--open');
  menuToggle.classList.toggle('menu-toggle--open');

  if(menu.classList.contains('mobile-menu--open')) {
    gsap.to(menu, {
      autoAlpha: 1,
      duration: .25,
    })
  }
  else {
    gsap.to(menu, {
      autoAlpha: 0,
      duration: .25,
    })
  }

  e.preventDefault();
})


// --------------------------------------------------
// 🌄 Image Gallery
// --------------------------------------------------

let imageGallery = document.querySelector('.image-gallery__inner');
if(imageGallery) {

  let prev = imageGallery.querySelector('.image-gallery__pagination--prev');
  let next = imageGallery.querySelector('.image-gallery__pagination--next');

  prev.addEventListener('mouseenter', () => {
    gsap.to('.image-gallery__image--prev img', {
      x: 20,
      duration: .25,
      ease: 'power2.inOut',
    })
  })

  prev.addEventListener('mouseleave', () => {
    gsap.to('.image-gallery__image--prev img', {
      x: 0,
      duration: .25,
      ease: 'power2.inOut',
    })
  })

  next.addEventListener('mouseenter', () => {
    gsap.to('.image-gallery__image--next img', {
      x: -20,
      duration: .25,
      ease: 'power2.inOut',
    })
  })

  next.addEventListener('mouseleave', () => {
    gsap.to('.image-gallery__image--next img', {
      x: 0,
      duration: .25,
      ease: 'power2.inOut',
    })
  })

  document.addEventListener('keydown', (e) => {
    if(e.key == "ArrowLeft") {
      prev.click();
    }
    if(e.key == "ArrowRight") {
      next.click();
    }
  })

}

// --------------------------------------------------
// 📰 News Accordion
// --------------------------------------------------

let articles = document.querySelectorAll('.article');
if(articles.length) {

  // let loadAnimation = gsap.timeline({
  //   paused: true,
  //   defaults: {
  //     ease: 'power1.inOut',
  //     duration: 1,
  //   }
  // });

  // loadAnimation.to(articles, {
  //   autoAlpha: 1,
  //   duration: 0.25,
  //   stagger: .05
  // })

  // window.addEventListener('load', () => {
  //   loadAnimation.play();
  // })

  function openArticle(article) {
    articles.forEach(otherArticle => {
      if(otherArticle.classList.contains('article--open') && otherArticle != article) {
        otherArticle.classList.remove('article--open');
      }
    })
    article.classList.add('article--open');
    history.pushState(null, null, '#' + article.getAttribute('id'));
  }
  
  function closeArticle(article) {
    if(article.classList.contains('article--open')) {
      article.classList.remove('article--open');
    }
  }

  if(window.location.hash && window.location.hash != '#!') {
    let article = document.querySelector(window.location.hash);
    if(article) {
      openArticle(article);
    }
  }

  articles.forEach(article => {

    let articleLink = article.querySelector('.article-title__link');

    if(!articleLink) return;

    articleLink.addEventListener('click', e => {

      if(!gsap.isTweening('.articles')) {
        let state = Flip.getState('.article-content');
        let startHeight = gsap.getProperty('.articles', 'height');

        if(article.classList.contains('article--open')) {
          closeArticle(article);
          history.replaceState(null, null, '#!');
        }
        else {
          openArticle(article);
        }

        let endHeight = gsap.getProperty('.articles', 'height');

        let flip = Flip.from(state, {
          duration: .5,
          ease: 'power2.inOut',
          nested: true
        })
    
        flip.fromTo('.articles', {
          height: startHeight,
        }, {
          height: endHeight,
          duration: flip.duration(),
          ease: 'power2.inOut',
          clearProps: 'height',
        }, 0)
      }

      e.preventDefault();

    })
  })

}